<template>
  <app-toast
    class="delete-realestate-toast"
    :message="message"
  >
    <div
      class="toast-body"
      v-html="$t(&quot;real-estate.delete&quot;)"
    />
  </app-toast>
</template>

<script>
  import appToast from '@/components/app-toast'

  export default {
    name: 'DeleteRealestate',

    components: {
      'app-toast': appToast
    },
    props: {
      message: Object
    }
  }
</script>

<style lang='scss' rel='stylesheet/scss'>
  @import '~@/styles/vars.scss';

  .delete-realestate-toast {
    strong {
      color: map_get($palette-primary, main);
    }
  }
</style>
